import React from 'react';
import {Redirect} from 'react-router-dom';

const RedirectToDashboard = () => <Redirect to={'/dashboard'}/>

export default RedirectToDashboard;